export const countries = [
    { name: "USA", flag: "https://flagcdn.com/48x36/us.png" },
    { name: "UK", flag: "https://flagcdn.com/48x36/gb.png" },
    { name: "UAE", flag: "https://flagcdn.com/48x36/ae.png" },
    { name: "Australia", flag: "https://flagcdn.com/48x36/au.png" },
    { name: "Canada", flag: "https://flagcdn.com/48x36/ca.png" },
    { name: "Tanzania", flag: "https://flagcdn.com/48x36/tz.png" },
    { name: "Kenya", flag: "https://flagcdn.com/48x36/ke.png" },
    { name: "Brazil", flag: "https://flagcdn.com/48x36/br.png" },
    { name: "Poland", flag: "https://flagcdn.com/48x36/pl.png" },
    { name: "Estonia", flag: "https://flagcdn.com/48x36/ee.png" },
    { name: "Germany", flag: "https://flagcdn.com/48x36/de.png" },
    { name: "France", flag: "https://flagcdn.com/48x36/fr.png" },
    { name: "Italy", flag: "https://flagcdn.com/48x36/it.png" },
    { name: "Spain", flag: "https://flagcdn.com/48x36/es.png" },
    { name: "India", flag: "https://flagcdn.com/48x36/in.png" },
    { name: "China", flag: "https://flagcdn.com/48x36/cn.png" },
    { name: "Japan", flag: "https://flagcdn.com/48x36/jp.png" },
    { name: "South Korea", flag: "https://flagcdn.com/48x36/kr.png" },
    { name: "Mexico", flag: "https://flagcdn.com/48x36/mx.png" },
    { name: "Argentina", flag: "https://flagcdn.com/48x36/ar.png" },
    { name: "Russia", flag: "https://flagcdn.com/48x36/ru.png" },
    { name: "South Africa", flag: "https://flagcdn.com/48x36/za.png" },
    { name: "Egypt", flag: "https://flagcdn.com/48x36/eg.png" },
    { name: "Saudi Arabia", flag: "https://flagcdn.com/48x36/sa.png" },
    { name: "Nigeria", flag: "https://flagcdn.com/48x36/ng.png" },
    { name: "Morocco", flag: "https://flagcdn.com/48x36/ma.png" },
    { name: "Sweden", flag: "https://flagcdn.com/48x36/se.png" },
    { name: "Norway", flag: "https://flagcdn.com/48x36/no.png" },
    { name: "Denmark", flag: "https://flagcdn.com/48x36/dk.png" },
    { name: "Switzerland", flag: "https://flagcdn.com/48x36/ch.png" },
    { name: "Netherlands", flag: "https://flagcdn.com/48x36/nl.png" },
    { name: "Belgium", flag: "https://flagcdn.com/48x36/be.png" },
    { name: "Greece", flag: "https://flagcdn.com/48x36/gr.png" },
    { name: "Portugal", flag: "https://flagcdn.com/48x36/pt.png" },
    { name: "Turkey", flag: "https://flagcdn.com/48x36/tr.png" },
    { name: "Ireland", flag: "https://flagcdn.com/48x36/ie.png" },
    { name: "New Zealand", flag: "https://flagcdn.com/48x36/nz.png" },
    { name: "Thailand", flag: "https://flagcdn.com/48x36/th.png" },
    { name: "Singapore", flag: "https://flagcdn.com/48x36/sg.png" },
    { name: "Malaysia", flag: "https://flagcdn.com/48x36/my.png" },
    { name: "Indonesia", flag: "https://flagcdn.com/48x36/id.png" },
    { name: "Vietnam", flag: "https://flagcdn.com/48x36/vn.png" },
    { name: "Philippines", flag: "https://flagcdn.com/48x36/ph.png" },
    { name: "Brazil", flag: "https://flagcdn.com/48x36/br.png" },
    { name: "Mexico", flag: "https://flagcdn.com/48x36/mx.png" },
    { name: "Argentina", flag: "https://flagcdn.com/48x36/ar.png" },
    { name: "Chile", flag: "https://flagcdn.com/48x36/cl.png" },
    { name: "Peru", flag: "https://flagcdn.com/48x36/pe.png" },
    { name: "Colombia", flag: "https://flagcdn.com/48x36/co.png" },
    { name: "Venezuela", flag: "https://flagcdn.com/48x36/ve.png" },
    { name: "Brazil", flag: "https://flagcdn.com/48x36/br.png" },
    { name: "Uruguay", flag: "https://flagcdn.com/48x36/uy.png" },
    { name: "Paraguay", flag: "https://flagcdn.com/48x36/py.png" },
    { name: "Bolivia", flag: "https://flagcdn.com/48x36/bo.png" },
    { name: "Ecuador", flag: "https://flagcdn.com/48x36/ec.png" },
    { name: "Panama", flag: "https://flagcdn.com/48x36/pa.png" },
    { name: "Costa Rica", flag: "https://flagcdn.com/48x36/cr.png" },
    { name: "Guatemala", flag: "https://flagcdn.com/48x36/gt.png" },
    { name: "Cuba", flag: "https://flagcdn.com/48x36/cu.png" },
    { name: "Haiti", flag: "https://flagcdn.com/48x36/ht.png" },
    { name: "Dominican Republic", flag: "https://flagcdn.com/48x36/do.png" },
    { name: "Jamaica", flag: "https://flagcdn.com/48x36/jm.png" },
    { name: "Bahamas", flag: "https://flagcdn.com/48x36/bs.png" },
];